import { useTranslation } from 'react-i18n-lite'

import Language from '../components/Language'
import { useLoginContext } from './LoginContext'
import {
  Button,
  feedbackcard,
  LinkButton,
  Unifree
} from '@yes.technology/react-toolkit'
import { useState } from 'react'

type Props = {
  goToAuthentication: () => void
}

function Identification({ goToAuthentication }: Props) {
  const { t } = useTranslation()
  const { userID, setUserID, captcha, isCaptchaDisabled } = useLoginContext()
  const [isAuthenticating, setIsAuthenticating] = useState(false)
  const [isUserIDInvalid, setIsUserIDInvalid] = useState(false)

  const handleSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault()

    if (!userID) {
      setIsUserIDInvalid(true)
      feedbackcard(t('login.identification.input-error.title'), {
        message: t('login.identification.input-error.message'),
        type: 'error',
        autoClose: 5000
      })

      return
    }

    setIsAuthenticating(true)
    goToAuthentication()
  }

  const onUserIDChange = (value: string) => {
    setIsUserIDInvalid(!value)
    setUserID(value)
  }

  return (
    <form
      noValidate
      style={{ display: 'flex', flexDirection: 'column', gap: 8 }}
      onSubmit={handleSubmit}
    >
      <Language />
      <Unifree
        label={t('login.identification.user')}
        placeholder={t('login.identification.user')}
        name='email'
        autoFocus
        value={userID}
        onChange={onUserIDChange}
        statusClass={isUserIDInvalid ? 'error' : undefined}
        required
      />

      <Button
        type='submit'
        heightClass='regular'
        disabled={
          !userID || isAuthenticating || (!isCaptchaDisabled && !captcha)
        }
      >
        {t('login.identification.continue')}
      </Button>

      <LinkButton href='/signup' variant='secondary' heightClass='regular'>
        {t('login.identification.want-to-sign-up')}
      </LinkButton>
    </form>
  )
}

export default Identification
